import React, { useState } from 'react';
import { Button, CircularProgress, TextField } from '@mui/material';
import { PaymentsCard, PaymentsContainer, PaymentsWrapper } from './Payments.styled';
import { useApi } from '../../../hooks/UseApi';
import {parseError} from "../../../errors/http.service";
import {useSnackbar} from "../../../contexts/SnackbarContext";
import {useTranslation} from 'react-i18next';

const Payments = () => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState<number | ''>('');
  const [loading, setLoading] = useState(false);
  const { makePayment } = useApi();
  const {showSnackbar} = useSnackbar();

  const handlePayment = async () => {
    if (typeof amount === 'number' && amount > 0) {
      setLoading(true);
      try {
        const response = await makePayment(amount);
        window.open(response.paymentUrl, '_blank');
      } catch (error) {
        console.error('Błąd podczas przetwarzania płatności:', error);
          showSnackbar(parseError(error), "error");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <PaymentsContainer>
      <PaymentsWrapper>
        <PaymentsCard>
          <h1>{t('payments.title')}</h1>
          <TextField
            label={t('payments.amount')}
            type="number"
            value={amount}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*\.?\d*$/.test(value)) {
                setAmount(value === '' ? '' : Number(value));
              }
            }}
            InputProps={{
              endAdornment: <span>{t('payments.currency')}</span>,
            }}
            variant="outlined"
            margin="normal"
            sx={{ width: '260px' }}
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            disabled={!amount || loading}
            onClick={handlePayment}
            sx={{ mt: 2, py: 1.5 }}
          >
            {loading ? <CircularProgress size={24} /> : t('payments.payButton')}
          </Button>
        </PaymentsCard>
      </PaymentsWrapper>
    </PaymentsContainer>
  );
};

export default Payments;
